import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import { ROSTER_SPARE_CONFIRM_FIELD } from '../../features/game/attendance/utils/rosterSpareConfirm'

export interface UpdateRosterSpareConfirmationArgs {
  gameId: string
  rosterId: string
  playerId: string
  confirmed: boolean
}

// Confirm / unconfirm a roster spare for this game (SN-8476). Stored per game.
// PUT /games/{game}/rosters/{roster}/players/{player}/attendance-data
export const updateRosterSpareConfirmation = async ({
  gameId,
  rosterId,
  playerId,
  confirmed,
}: UpdateRosterSpareConfirmationArgs): Promise<void> => {
  await req(
    ENDPOINTS.GAMES.UPDATE_GAME_ROSTER_PLAYER_ATTENDANCE_DATA(
      gameId,
      rosterId,
      playerId
    ),
    {
      method: 'PUT',
      body: JSON.stringify({ [ROSTER_SPARE_CONFIRM_FIELD]: confirmed }),
    }
  )
}
